"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.multiSelectedValueFormatter = multiSelectedValueFormatter;
var _react = _interopRequireDefault(require("react"));
var _GroupChip = require("../components/MultiPicker/GroupChip");
var _GroupedValueChip = require("../components/MultiPicker/GroupedValueChip");
var _IndividualChip = require("../components/MultiPicker/IndividualChip");
var _types = require("../types");
var _getOptionKey = require("./getOptionKey");
function multiSelectedValueFormatter(option, optionProps, isGroupedOption, groupedValue, onViewMembers, onExpandMembers, isInvalidContact, chipType) {
  const isGroup = option ? (0, _types.isGroupContact)(option) : false;
  if (isGroupedOption) {
    return /*#__PURE__*/_react.default.createElement(_GroupedValueChip.GroupedValueChip, {
      key: `cpmcp-groupedselectionchip-${groupedValue}`,
      optionProps: optionProps,
      groupedValue: groupedValue
    });
  } else if (isGroup && option) {
    return /*#__PURE__*/_react.default.createElement(_GroupChip.GroupChip, {
      key: (0, _getOptionKey.getOptionKey)(option),
      option: option,
      optionProps: optionProps,
      onExpandMembers: onExpandMembers,
      onViewMembers: onViewMembers,
      chipType: chipType
    });
  } else if (option) {
    return /*#__PURE__*/_react.default.createElement(_IndividualChip.IndividualChip, {
      key: (0, _getOptionKey.getOptionKey)(option),
      option: option,
      optionProps: optionProps,
      isInvalidContact: isInvalidContact,
      chipType: chipType
    });
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
}
//# sourceMappingURL=multiSelectedValueFormatter.js.map